import { render } from "./RewardsView.vue?vue&type=template&id=bd2038d8&scoped=true"
import script from "./RewardsView.vue?vue&type=script&lang=js"
export * from "./RewardsView.vue?vue&type=script&lang=js"

import "./RewardsView.vue?vue&type=style&index=0&id=bd2038d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd2038d8"]])

export default __exports__